var map = {
	"./ktba/development.json": 900,
	"./ktba/production.json": 901,
	"./ktba/staging.json": 902,
	"./okba/development.json": 903,
	"./okba/production.json": 904,
	"./okba/staging.json": 905
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 899;